if (!Object.entries) {
	Object.entries = (obj) => {
		var ownProps = Object.keys(obj),
			i = ownProps.length,
			resArray = new Array(i); 
		while (i--)
			resArray[i] = [ownProps[i], obj[ownProps[i]]];

		return resArray;
	};
}

export const getSettings = () => {
	return fetch('/settings.json').then((response) => {
		return response.json();
	});
}

export const getQueryStringParameter = (queryString, key) => {
	const queryStringObj = new URLSearchParams(queryString);
	const keyLower = key.toLowerCase();

	for (const key of queryStringObj.keys()) {
		if (key.toLowerCase() === keyLower) {
			return queryStringObj.get(key) ?? '';
		}
	}
}
export const deepFormFieldSearch = (form, key, value) => {
	if (form.hasOwnProperty(key) && form[key] === value) {
		return form;
	} else if (form.hasOwnProperty('components')) {
		for (let k = 0; k < form.components.length; k++) {
			if (typeof form.components[k] === "object") {
				const o = deepFormFieldSearch(form.components[k], key, value);
				if (o !== null && typeof o !== 'undefined')
					return o;
			}
		}
	} else if (form.hasOwnProperty('columns')) {
		for (let k = 0; k < form.columns.length; k++) {
			if (typeof form.columns[k] === "object") {
				const o = deepFormFieldSearch(form.columns[k], key, value);
				if (o !== null && typeof o !== 'undefined')
					return o;
			}
		}
	}
}

export const createComponentMapping = (startingNode, pathKey = '__fhirPath') => {
	const resourceKey = 'fhirResource';
	const elementKey = 'fhirElement';
	let mapping = {};

	let __mapping_helper = function (node, root, path, parentKey) {
		if (node.hasOwnProperty('components')) {
			let parent = node.type === 'datagrid' ? node.key : '';
			node.components.forEach(component =>
				__mapping_travese_helper(component, node, root, path, parent));

		} else if (node.hasOwnProperty('columns')) {
			node.columns.forEach(component =>
				__mapping_travese_helper(component, node, root, path));

		} else if (node.key && node.properties) {
			Object.keys(node.properties).forEach(fhirElementKey => {
				let regex = new RegExp('^' + elementKey + '\(\\[(\\d+)?\\])?$', 'i');
				let match = regex.exec(fhirElementKey); // 0: full key, 2: index

				if (match !== null) {
					let _elementKey = match[0];
					let el = node.properties[_elementKey];

					if (el && el[0] === el[0].toLowerCase()) {
						console.warn(`[eForms] Field "${node.key}" has incorrect fhirElement ${_elementKey}="${node.properties[_elementKey]}" starts with lower case character`);

						el = el.charAt(0).toUpperCase() + el.slice(1);
					}

					let fhirPathMapValue = el.startsWith(root, 0) ? el.replace(root, path) : el;
					let fhirPathMapKey = parentKey ? `${parentKey}[${(match[2] || '')}].${node.key}` : node.key;

					mapping[fhirPathMapKey] = fhirPathMapValue;
				}
			});
		}
	};

	let __mapping_travese_helper = function (component, node, root, path, parentKey) {
		if (node?.properties?.hasOwnProperty(resourceKey)) {
			if (!node.properties[elementKey]) {
				console.warn(`[eForms] Field "${node.key}" has ${resourceKey}="${node.properties[resourceKey]}", but missing ${elementKey}. Assuming ${elementKey} = "${node.properties[resourceKey]}"`);

				node.properties[elementKey] = node.properties[resourceKey];
			}

			if (!path) {
				path = node.properties[resourceKey];
            }

			__mapping_helper(component,
				node.properties[resourceKey],
				node.properties[elementKey] ? node.properties[elementKey].replace(node.properties[resourceKey], path || '') : '',
				parentKey);
		} else {
			__mapping_helper(component, root, path, parentKey);
		}
	};

	__mapping_helper(startingNode);
	return mapping;
}

export const mergeObjects = (oldObject, newObject) => {
	let output = JSON.parse(JSON.stringify(oldObject));

	const recursiveObjectTraversal = (obj1, obj2) => {
		if (obj1.constructor.name !== 'Array' && typeof obj1 === 'object') {
			for (const [key, value] of Object.entries(obj1)) {
				let obj2Key = obj2[key];
				if (!obj2Key) {
					obj2Key = null;
				}

				const subtree = recursiveObjectTraversal(value, obj2Key);

				if (subtree) {
					obj2[key] = subtree;
				}
			}
		} else {
			if (obj1 === null || obj1 === undefined) {
				return obj2;
			} else {
				return obj1;
			}
		}
	}

	recursiveObjectTraversal(newObject, output);
	return output;
}
/**
 * Format bytes as human-readable text.
 *
 * @param bytes Number of bytes.
 * @param si True to use metric (SI) units, aka powers of 1000. False to use
 *           binary (IEC), aka powers of 1024.
 * @param dp Number of decimal places to display.
 *
 * @return Formatted string.
 */
export const humanFileSize = (bytes, si = true, dp = 1) => {
	const thresh = si ? 1000 : 1024;

	if (Math.abs(bytes) < thresh) {
		return bytes + ' B';
	}

	const units = si
		? ['kB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB']
		: ['KiB', 'MiB', 'GiB', 'TiB', 'PiB', 'EiB', 'ZiB', 'YiB'];
	let u = -1;
	const r = 10 ** dp;

	do {
		bytes /= thresh;
		++u;
	} while (Math.round(Math.abs(bytes) * r) / r >= thresh && u < units.length - 1);


	return bytes.toFixed(dp) + ' ' + units[u];
}

export const isObjectEmpty = (obj) => {
	return obj && Object.keys(obj).length === 0 && obj.constructor === Object;
}

export const isDebugging = () => {
	return process.env.NODE_ENV === 'development';
}